import { Amplify } from 'aws-amplify'
import { generateClient } from 'aws-amplify/api'

export type { GraphQLResult } from 'aws-amplify/api'

class Client {
  public token: string | null
  private isConfigured: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private client: any

  constructor() {
    this.token = null
    this.isConfigured = false
    this.client = null
  }

  private configure() {
    if (this.isConfigured) {
      return
    }

    // Use closure to capture 'this' for dynamic token access
    const self = this

    Amplify.configure(
      {
        API: {
          GraphQL: {
            endpoint: process.env.VUE_APP_GRAPHQL_API_END_POINT || '',
            region: process.env.VUE_APP_GRAPHQL_REGION || '',
            defaultAuthMode: 'oidc',
          },
        },
      },
      {
        API: {
          GraphQL: {
            // Dynamic header - token is read on each request
            headers: async () => ({
              Authorization: self.token || '',
              'Accept-Encoding': 'gzip',
            }),
          },
        },
        Auth: {
          tokenProvider: {
            // Dynamic token provider - returns current token on each request
            getTokens: async () => ({
              accessToken: {
                toString: () => self.token || '',
                payload: {},
              },
              idToken: {
                toString: () => self.token || '',
                payload: {},
              },
            }),
          },
        },
      }
    )

    this.client = generateClient()
    this.isConfigured = true
  }

  public connection() {
    if (!this.token) return null

    // Configure once, reuse connection
    // Token changes are handled dynamically via closure
    this.configure()
    return this.client
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const client: any = new Client()

export default client
